// features/module-master.dependencies.js

import apiModuleMaster from "../api";

export const loadModuleMasterDependencies = async () => {
  const modulesRes = await apiModuleMaster.getAllModules().catch(() => null);

  const modules = modulesRes?.data?.data || [];

  // Sidebar supports two levels, so only top-level modules can be parents.
  // The path is shown next to the name to tell apart modules that share a name.
  const parentModules = modules.filter((m) => !m.parent_fid);

  // Every module, for the "Is Parent Module" flag (see module-master.parent.js).
  // Left undefined when the call failed, rather than an empty list that would
  // make every module look like it has no sub-modules.
  return { parentModules, modules: modulesRes ? modules : undefined };
};
